import { AfterContentChecked, Component, Input, OnInit } from '@angular/core';
import { ToastBannerService } from './toast-banner.service';

@Component({
  selector: 'toast-banner',
  templateUrl: './toast-banner.component.html',
  styleUrls: ['./toast-banner.component.scss'],
})
export class ToastBannerComponent implements OnInit, AfterContentChecked {
  bannerOpen: Boolean = false;
  bannerParams = {
    lineColor: null,
    icon: null,
    title: null,
    desc: 'Something went wrong',
    bigIcon: false,
    closeIcon: true,
  };

  constructor(private toastBannerService: ToastBannerService) {}

  ngOnInit() {}

  ngAfterContentChecked() {
    if (this.toastBannerService.bannerOpen === true) {
      this.bannerOpen = true;
      this.bannerParams = this.toastBannerService.getBannerParams();
    }

    if (this.toastBannerService.bannerOpen === false) {
      this.closeBanner();
    }
  }

  closeBanner() {
    this.toastBannerService.clearBannerParams();
    this.bannerOpen = false;
  }
}
